var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Locked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Locked"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F7A500",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,3 C8.1045695,3 9,3.8954305 9,5 L9.00079851,6.00841863 C9.2437935,6.025429 9.36573413,6.06795171 9.48842285,6.13356635 C9.65138581,6.2207199 9.7792801,6.34861419 9.86643365,6.51157715 C9.95358719,6.67454011 10,6.83618323 10,7.2819426 L10,9.7180574 C10,10.1638168 9.95358719,10.3254599 9.86643365,10.4884229 C9.7792801,10.6513858 9.65138581,10.7792801 9.48842285,10.8664336 C9.32545989,10.9535872 9.16381677,11 8.7180574,11 L5.2819426,11 C4.83618323,11 4.67454011,10.9535872 4.51157715,10.8664336 C4.34861419,10.7792801 4.2207199,10.6513858 4.13356635,10.4884229 C4.04641281,10.3254599 4,10.1638168 4,9.7180574 L4,7.2819426 C4,6.83618323 4.04641281,6.67454011 4.13356635,6.51157715 C4.2207199,6.34861419 4.34861419,6.2207199 4.51157715,6.13356635 C4.63442137,6.06786855 4.7565156,6.02532125 5.00012601,6.00835408 L5,5 C5,3.8954305 5.8954305,3 7,3 Z M7,4 C6.48716416,4 6.06449284,4.38604019 6.00672773,4.88337887 L6,5 L6,6 L8,6 L8,5 C8,4.44771525 7.55228475,4 7,4 Z",
    id: "Rectangle-3",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/Locked.e79c957a09cd354103137169a7e4f0b3.svg";
export { ForwardRef as ReactComponent };